import React from "react";
import { Navigate, useParams } from "react-router-dom";
import DoctorBiopsyCreate from "../doctor/DoctorBiopsyCreate";
import DoctorBiopsyEdit from "../doctor/DoctorBiopsyEdit";
import LabBiopsyCreate from "../lab/LabBiopsyCreate";
import AdminBiopsyCreate from "../admin/AdminBiopsyCreate";

export default function BiopsyFormDispatcher() {
  const { id } = useParams();
  const userType = (localStorage.getItem("userType") || "").toLowerCase().trim();
  if (userType === "doctor") return id ? <DoctorBiopsyEdit /> : <DoctorBiopsyCreate />;
  if (userType === "lab technician") return id ? <Navigate to={`/biopsy/cases/${id}`} replace /> : <LabBiopsyCreate />;
  if (userType === "admin")  return <AdminBiopsyCreate />;
  return <Navigate to="/biopsy/cases" replace />;
}
